import axios from "@/plugins/customAxios";
import {
  DateTimeInterface,
  EventInterface,
  EventPostObject,
  PersistedEventInterface,
  PlayerSlotInterface,
  SlotGroupInterface,
  SlotTag,
} from "@/types";
import PlayerSlot from "./PlayerSlot";

export default class EventService {
  public static async saveEvent(event: Partial<EventInterface>) {
    const response = await axios.post(
      "/arma/events",
      await this.transformLocalEvent(event)
    );
    return response.data;
  }

  public static async getFutureEvents(events: PersistedEventInterface[]): Promise<PersistedEventInterface[]> {
    if (events.length === 0) {
      return [];
    }
    const today = new Date();
    let currentEventIndex = events.length - 1;

    const result: PersistedEventInterface[] = [];

    while (
      this.getDateFromDateTime(events[currentEventIndex].date) >= today &&
      currentEventIndex > 0
    ) {
      result.unshift(events[currentEventIndex]);
      currentEventIndex--;
    }

    return result;
  }

  private static async transformLocalEvent(
    event: Partial<EventInterface>
  ): Promise<EventPostObject> {

    const eventObject: Partial<EventPostObject> = {
      name: event.name!.trim(),
      description: event.description!.trim(),
      modpack: event.modpack,
      date: event.date,
      slotGroups: [],
    };

    if (event.slotGroups) {
      const slotGroups: SlotGroupInterface[] = [];
      event.slotGroups.forEach((slotGroup) => {
        delete slotGroup.hasDefaultName;
        const slotGroupObject = {
          name: slotGroup.name.trim(),
          description: slotGroup.description!.trim() || "",
          playerSlots: [] as Array<{ name: string; description: string; leader: boolean; tags?: SlotTag[] | string[] }>,
          lotterySlots: [] as Array<{ name: string; description: string; tags?: SlotTag[] | string[] }>,
        };

        slotGroup.playerSlots.forEach((playerSlot) => {
          if (playerSlot.lottery) {
            slotGroupObject.lotterySlots.push({
              name: playerSlot.name,
              description: playerSlot.description,
              tags: playerSlot.tags
            });
          } else {
            slotGroupObject.playerSlots.push({
              name: playerSlot.name,
              description: playerSlot.description,
              leader: playerSlot.leader,
              tags: playerSlot.tags
            });
          }
        });

        eventObject.slotGroups!.push(slotGroupObject);


        slotGroups.push(slotGroup);
      });

      event.slotGroups = slotGroups;
    }

    if (event.image === undefined) {
      delete event.image;
    } else {
      eventObject.image = await this.base64EncodeImage(event.image as File);
    }

    return eventObject as EventPostObject;
  }

  private static base64EncodeImage(image: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result);
      };
      reader.onerror = (error) => reject(error);
    });
  }

  private static getDateFromDateTime(date: DateTimeInterface): Date {
    return new Date(Date.parse(date.date));
  }
}
